module.exports = __webpack_public_path__ + "static/img/game-logo-sexy.46f5523.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-sexy.png
// module id = w+Tw
// module chunks = 0 1 2 3 4 5 6